export const BANNER_SCHEDULE_TYPES = {
  ONE_TIME: "ONE_TIME",
  RECURRENT: "RECURRENT",
};

export const BANNER_SCHEDULE_TYPES_CHOICES = [
  { id: BANNER_SCHEDULE_TYPES.ONE_TIME, name: "Una vez" },
  { id: BANNER_SCHEDULE_TYPES.RECURRENT, name: "Recurrente" },
];
